import { render, staticRenderFns } from "./RemoveOrderComponent.vue?vue&type=template&id=e276dcd0&scoped=true&"
import script from "./RemoveOrderComponent.vue?vue&type=script&lang=js&"
export * from "./RemoveOrderComponent.vue?vue&type=script&lang=js&"
import style0 from "./RemoveOrderComponent.vue?vue&type=style&index=0&id=e276dcd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e276dcd0",
  null
  
)

export default component.exports